import {
  CreateExperienceCustomMetricFe,
  CreateExperienceKeyMetricDto,
} from "@intelligems/ig-types";
import { sortByOrder } from "@src/utils/sortings";

export const ensureAndSortOrder = <T extends { order: number }>(
  arr: T[]
): T[] => {
  return [...arr].sort(sortByOrder).map((item, index) => ({
    ...item,
    order: index,
  }));
};
export const filterOutRemovedMetrics = (
  keyMetrics: CreateExperienceKeyMetricDto[],
  customMetrics: CreateExperienceCustomMetricFe[],
  keptCustomEventIds: string[],
  keptStandardEventIds: string[]
) => {
  return keyMetrics.filter((keyMetric) => {
    const foundExistingCustomMetric = customMetrics.find(
      (customMetric) => customMetric.id === keyMetric.experienceCustomMetricId
    );

    return (
      (keyMetric.standardEventId &&
        keptStandardEventIds.includes(keyMetric.standardEventId)) ||
      (keyMetric.experienceCustomMetricId &&
        foundExistingCustomMetric &&
        keptCustomEventIds.includes(foundExistingCustomMetric.customEventId))
    );
  });
};

export const filterOutRemovedCustomFromKey = (
  keyMetrics: CreateExperienceKeyMetricDto[],
  customMetrics: CreateExperienceCustomMetricFe[]
) => {
  return keyMetrics.filter(
    (keyMetric) =>
      keyMetric.standardEventId ||
      (keyMetric.experienceCustomMetricId &&
        customMetrics
          .map((customMetric) => customMetric.id)
          .includes(keyMetric.experienceCustomMetricId))
  );
};
